import type { DateRange } from '../types';

/** Today as YYYY-MM-DD */
export function todayISO(): string {
  const d = new Date();
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

/** This weekend: Saturday–Sunday of this week (or next if we're past Saturday). */
export function thisWeekendRange(): DateRange {
  const d = new Date();
  const day = d.getDay();
  const sat = new Date(d);
  const sun = new Date(d);
  if (day === 0) {
    sat.setDate(sat.getDate() - 1);
  } else if (day < 6) {
    sat.setDate(sat.getDate() + (6 - day));
    sun.setDate(sun.getDate() + (7 - day));
  } else {
    sun.setDate(sun.getDate() + 1);
  }
  return {
    from: toISO(sat),
    to: toISO(sun),
  };
}

/** First and last day of current month. */
export function thisMonthRange(): DateRange {
  const d = new Date();
  const from = new Date(d.getFullYear(), d.getMonth(), 1);
  const to = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  return { from: toISO(from), to: toISO(to) };
}

/** First and last day of next month. */
export function nextMonthRange(): DateRange {
  const d = new Date();
  const from = new Date(d.getFullYear(), d.getMonth() + 1, 1);
  const to = new Date(d.getFullYear(), d.getMonth() + 2, 0);
  return { from: toISO(from), to: toISO(to) };
}

function toISO(d: Date): string {
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

export type DateShortcut = 'weekend' | 'month' | 'nextmonth';

export function dateShortcutToRange(s: DateShortcut): DateRange {
  switch (s) {
    case 'weekend':
      return thisWeekendRange();
    case 'month':
      return thisMonthRange();
    case 'nextmonth':
      return nextMonthRange();
    default:
      return null;
  }
}
